"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldPopoverCoreInputs = void 0;
//default values for the inputs
class EmeraldPopoverCoreInputs {
    constructor() {
        this.id = Math.random().toString(36).substr(2, 9);
        this.placement = 'auto';
        this.visible = false;
        this.width = '360px';
    }
}
exports.EmeraldPopoverCoreInputs = EmeraldPopoverCoreInputs;
//# sourceMappingURL=popover.inputs.js.map